module.exports = __webpack_public_path__ + "img/meng.9733b6d8.png";